/* eslint-disable @typescript-eslint/ban-ts-comment */
import Input from "../../Shared/Input";
import TextArea from "../../Shared/TextArea";
import ImgPlaceholder from "../../../assets/ImgPlaceholder.svg";
import PencilIcon from "../../Icons/PencilIcon";
import Button from "../../Shared/Button";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ButtonTypes } from "../../../utils/consts";
import AddIcon from "../../Icons/AddIcon";
import { AddInstructor } from "../../../api/Instructor/AddInstructor";
import UploadProfile from "../../Shared/UploadProfile";
import { queryClient } from "../../../main";
import { toast } from "react-toastify";
const validationSchema = Yup.object({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  phone: Yup.string().required("Mobile number is required"),
  country: Yup.string().required("Country is required"),
  university: Yup.string().required("University is required"),
  city: Yup.string().required("City is required"),
  photo: Yup.string().required("Photo is required"),
  bio: Yup.string().required("Bio is required"),
  description: Yup.string().required("Description is required"),

});

const AddNewMember = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { mutate , error } = useMutation({
    mutationFn: AddInstructor,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["instructors"] });
      toast.success("Instructor Added successfully");
      formik.resetForm();
      onSuccess && onSuccess();
    },
    onError: () => {
      formik.setSubmitting(false);
    },
  });

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      university: "",
      city: "",
      phone: "",
      photo: "",
      country: "",
      bio: "",
      description: "",
      facebook: "",
      linkedin: ""
    },
    validationSchema,
    onSubmit: (values) => {
      //@ts-ignore
      mutate(values);
    },
  });
  const handleimgUrlUpload = (url: string) => {
    formik.setFieldValue('photo', url);
  };

  return (
    <div className="py-7">
      <h1 className="text-burntBlack font-bold text-[32px] mb-7">Profile</h1>
      <div className="p-8 rounded-xl bg-white border-black/15 shadow flex flex-col justify-end pt-40">
        <form onSubmit={formik.handleSubmit} className="flex gap-12">
          <div className="relative size-[132px] rounded-full object-cover cursor-pointer">
            <UploadProfile folder="user-images" onFileUploaded={handleimgUrlUpload}>
              <div className="absolute z-50 right-0 w-8 h-8 bg-[#2783E9] rounded-full flex items-center justify-center bottom-7">
                <PencilIcon />
              </div>
              {formik.values.photo && formik.values.photo !== "" && formik.values.photo !== "uploading" ? (
                <img className="rounded-full" src={formik.values.photo} />
              ) : (
                <img className="rounded-full" src={ImgPlaceholder} />
              )}            
              </UploadProfile>
          </div>
          <div className="w-full space-y-5">
            <div className="flex gap-7 w-full">
              <Input
                value={formik.values.firstName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.firstName && formik.errors.firstName
                    ? formik.errors.firstName
                    : ""
                }
                className="w-full"
                title="First Name"
                inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                name="firstName"
                placeholder=""
              />
              <Input
                value={formik.values.lastName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.lastName && formik.errors.lastName
                    ? formik.errors.lastName
                    : ""
                }
                className="w-full"
                title="Last Name"
                inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                name="lastName"
                placeholder=""
              />
            </div>
            <div className="flex gap-7 w-full">
              <Input
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.email && formik.errors.email
                    ? formik.errors.email
                    : ""
                }
                className="w-full"
                title="Email"
                inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                name="email"
                placeholder=""
              />
              <Input
                value={formik.values.university}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.university && formik.errors.university
                    ? formik.errors.university
                    : ""
                }
                className="w-full"
                title="University"
                inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                name="university"
                placeholder=""
              />
            </div>
            <Input
                value={formik.values.phone}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.phone && formik.errors.phone
                    ? formik.errors.phone
                    : ""
                }
                className="w-full"
                title="Mobile Number"
                inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                name="phone"
                placeholder=""
              />

            <div className="flex gap-7 w-full">
              <Input
                value={formik.values.country}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.country && formik.errors.country
                    ? formik.errors.country
                    : ""
                }
                className="w-full"
                title="Country"
                inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                name="country"
                placeholder=""
              />
              <Input
                value={formik.values.city}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.city && formik.errors.city
                    ? formik.errors.city
                    : ""
                }
                className="w-full"
                title="City"
                inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                name="city"
                placeholder=""
              />
            </div>
            <div className="flex gap-7 w-full">
              <Input
                value={formik.values.facebook}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.facebook && formik.errors.facebook
                    ? formik.errors.facebook
                    : ""
                }
                className="w-full"
                title="Faceobook"
                inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                name="facebook"
                placeholder=""
              />
              <Input
                value={formik.values.linkedin}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.linkedin && formik.errors.linkedin
                    ? formik.errors.linkedin
                    : ""
                }
                className="w-full"
                title="LinkedIn"
                inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                name="linkedin"
                placeholder=""
              />
            </div>

            <div className="flex gap-7 w-full">
              <TextArea
                value={formik.values.description}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.description && formik.errors.description
                    ? formik.errors.description
                    : ""
                }
                className="w-full"
                inputStyles="h-32  !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                title="Description"
                name="description"
                placeholder=""
              />
              <TextArea
                value={formik.values.bio}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.bio && formik.errors.bio
                    ? formik.errors.bio
                    : ""
                }
                className="w-full"
                inputStyles="h-32  !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                title="Bio"
                name="bio"
                placeholder=""
              />
            </div>

            <Button
              className="!h-12 w-40 !text-sm font-bold rounded-md ml-auto !bg-[#4379EE] hover:!bg-primary"
              variant="primary"
              type={ButtonTypes.SUBMIT}
            >
              <AddIcon className="mr-1.5" />
              Add Instructor
            </Button>
            {error instanceof AxiosError && (
                    <span className="text-red-500 font-bold text-lg">
                        {error?.response?.data?.message || "An error occurred"}
                    </span>
                )}

          </div>
        </form>
      </div>
    </div>
  );
};

export default AddNewMember;
